import { getAccount } from '@wagmi/core';

import { API, ApiTypeValues } from '../constants/api';
import { USER_SIGNED_JWT_MAP } from '../constants/localStorage';
import { onAuthenticate } from './authenticate';
import { getMapFromLoacalStorage } from './updateLocalStorageItem';

import { config } from '../index';

const getBaseHeader = () => ({
  'content-type': 'application/json; charset=utf-8',
});

export const getHeader = (jwt: string) => ({
  variance_secret: jwt,
  ...getBaseHeader(),
});

const getApi = (type: ApiTypeValues) => {
  return API[type];
};

const getJWT = (address?: `0x${string}`) => {
  if (address) {
    const jwt = getMapFromLoacalStorage(USER_SIGNED_JWT_MAP);
    const addrJwt = jwt && jwt[address];
    return addrJwt;
  }
  return '';
};

export async function post(
  apiType: ApiTypeValues,
  url: string,
  body: Record<string, any>
): Promise<Response> {
  try {
    //  @ts-ignore
    const { address } = getAccount(config);
    if (!address) throw new Error('Please connect wallet first');
    await onAuthenticate(address!);
    const basicDomain = getApi(apiType);
    const res = await fetch(`${basicDomain}${url}`, {
      method: 'POST',
      headers: getHeader(getJWT(address)),
      body: JSON.stringify(body),
    });
    return res;
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
}

export async function get(
  apiType: ApiTypeValues,
  url: string,
  query?: Record<string, any>
): Promise<Response> {
  try {
    //  @ts-ignore
    const { address } = getAccount(config);
    if (!address) throw new Error('Please connect wallet first');
    await onAuthenticate(address!);
    const basicDomain = getApi(apiType);
    const requestUrl = `${basicDomain}${url}${
      query ? '?' + new URLSearchParams(query).toString() : ''
    }`;
    const res = await fetch(requestUrl, {
      headers: getHeader(getJWT(address)),
    });
    return res;
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
}

export async function handleRes(
  res: Response,
  onSuccess?: (res: Response) => void
) {
  if (res.status === 200) {
    const finalRes = await res.json();
    await onSuccess?.(finalRes);
  } else {
    const errorMes = await res.json();
    throw new Error(errorMes.result);
  }
}

export async function getWithoutJWT(
  apiType: ApiTypeValues,
  url: string,
  query?: Record<string, any>
): Promise<Response> {
  try {
    const basicDomain = getApi(apiType);
    const requestUrl = `${basicDomain}${url}${
      query ? '?' + new URLSearchParams(query).toString() : ''
    }`;
    const res = await fetch(requestUrl, {
      headers: getBaseHeader(),
    });
    return res;
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
}
